module.exports = __webpack_public_path__ + "img/Sebastian.be1f9877.jpg";